module.exports = __webpack_public_path__ + "static/media/flow-activate.97047de2.png";